import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { Card } from '@/components/ui/card';
import { Factory } from 'lucide-react';
import { useProductWorkflow } from '@/hooks/useProductWorkflow';

export function CompletePage() {
  const navigate = useNavigate();
  const { productTitle, handleReset } = useProductWorkflow();

  const onReset = () => {
    handleReset();
    navigate('/');
  };

  return (
    <div className="space-y-6">
      <Card className="p-8 text-center">
        <div className="space-y-4">
          <div className="mx-auto w-16 h-16 bg-green-100 rounded-full flex items-center justify-center">
            <Factory className="h-8 w-8 text-green-600" />
          </div>
          <div>
            <h2 className="text-2xl font-bold mb-2">Production Complete!</h2>
            <p className="text-muted-foreground">
              {productTitle} is ready for export
            </p>
          </div>
          <div className="flex gap-3 justify-center pt-4">
            <Button variant="outline" onClick={onReset}>
              Create Another Product
            </Button>
            <Button>
              Export to CSV
            </Button>
          </div>
        </div>
      </Card>
    </div>
  );
}
